import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import locale from 'date-fns/locale/de';
import Link from '../Link';

const ExternalDocumentLink = ({ title, createdAt, url, isPatient }) => (
  <div className="flex flex-col even:pt-4">
    <span>{format(createdAt, 'DD. MMMM YYYY, HH:mm', { locale })}</span>
    {isPatient ? (
      <span>{title}</span>
    ) : (
      <Link href={url} target="_blank" rel="noreferrer" className="self-start">
        {title}
      </Link>
    )}
  </div>
);

ExternalDocumentLink.propTypes = {
  title: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  isPatient: PropTypes.bool,
};

ExternalDocumentLink.defaultProps = {
  isPatient: false,
};

export default ExternalDocumentLink;
